import t from"react";import m from"antd/es/layout";import{useResponsiveStyle as a}from"utils";var{Content:f}=m,y=t.forwardRef((e,o)=>{let{style:r,children:s}=e,{className:n,styled:l}=a(r);return t.createElement(f,{style:l,className:n,ref:o},s)});export{y as default};
//# sourceMappingURL=index.js.map
